module.exports = __webpack_public_path__ + "img/icon-success.407fe2db.svg";